import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs/operators';
import { LoggerService } from '../../../services/logger.service';

interface FloatingRainStudent {
  customer_id: string;
  first_name: string;
  last_name: string;
  email?: string;
  cell_phone?: string;
  already_imported?: boolean;
}

@Component({
  selector: 'app-floatingrain-single-import',
  templateUrl: './floatingrain-single-import.component.html',
  styleUrls: ['./floatingrain-single-import.component.css'],
})
export class FloatingrainSingleImportComponent {
  searchTerm = '';
  isSearching = false;
  isImporting = false;
  searchResults: FloatingRainStudent[] = [];
  selectedStudent?: FloatingRainStudent;
  searchError = '';

  constructor(
    private dialogRef: MatDialogRef<FloatingrainSingleImportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { studioId: string; studioName?: string },
    private drupalRESTService: DrupalRESTService,
    private snackBar: MatSnackBar
  ) {}

  onSearch(): void {
    this.searchError = '';
    this.selectedStudent = undefined;

    const query = this.searchTerm.trim();
    if (query.length < 2) {
      this.searchError = 'Enter at least 2 characters to search.';
      return;
    }

    this.isSearching = true;
    this.drupalRESTService
      .httpGET(
        `/api_rest/v1/floatingrain/search-students?field_studio_reference=${this.data.studioId}&q=${encodeURIComponent(
          query
        )}`
      )
      .pipe(finalize(() => (this.isSearching = false)))
      .subscribe({
        next: (res: any) => {
          this.searchResults = res?.results ?? [];
          if (this.searchResults.length === 0) {
            this.searchError = 'No matches found.';
          }
        },
        error: (err) => {
          LoggerService.error('Floating Rain search failed', err);
          this.searchError = err?.error?.error || 'Search failed. Try again.';
        },
      });
  }

  selectStudent(student: FloatingRainStudent): void {
    this.selectedStudent = student;
  }

  importSelected(): void {
    if (!this.selectedStudent) {
      return;
    }

    this.isImporting = true;
    this.drupalRESTService
      .httpPOST('/api_rest/v1/floatingrain/import-student', {
        customer_id: this.selectedStudent.customer_id,
        field_studio_reference: this.data.studioId,
      })
      .pipe(finalize(() => (this.isImporting = false)))
      .subscribe({
        next: () => {
          this.snackBar.open('Student import started.', 'Close', { duration: 3500 });
          this.dialogRef.close(true);
        },
        error: (err) => {
          LoggerService.error('Floating Rain import failed', err);
          this.snackBar.open(err?.error?.error || 'Import failed.', 'Close', { duration: 4000 });
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
